module.exports = __webpack_public_path__ + "img/make_pc_02.8b6e4d10.png";